import gateway from '@/_gateway.config.js'
import { APPID } from '@/config/referral.js'
// import { getUriParam } from '@/utils'

export default function (channelId, activityCode, channelKeyword) {
  // 登录页
  // var paras = getUriParam()
  // var uri = location.href
  // if (!paras.activityCode) {
  //   uri = uri+
  // }
  let url = encodeURIComponent(location.href)
  return `${gateway.ssoUrl}/h5logincenter?appId=${APPID}&channel_id=${channelId}&activityCode=${activityCode || ''}&channelKeyword=${channelKeyword}&redirect_uri=${url}`
}
